import { render, staticRenderFns } from "./slidePicDetail.vue?vue&type=template&id=1185e798&scoped=true&"
import script from "./slidePicDetail.vue?vue&type=script&lang=js&"
export * from "./slidePicDetail.vue?vue&type=script&lang=js&"
import style0 from "./slidePicDetail.vue?vue&type=style&index=0&id=1185e798&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1185e798",
  null
  
)

export default component.exports